import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import api from '@/lib/api';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setError('');
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Reset failed. Link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <h1 className="font-display text-xl font-bold text-foreground mb-2">Invalid reset link</h1>
        <Link to="/login" className="text-sm" style={{ color: '#E04B2A' }} data-testid="reset-back-to-login">Back to sign in</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="w-full max-w-sm">
        <h1 className="font-display text-2xl font-bold text-foreground tracking-tight mb-2">Set new password</h1>
        {done ? (
          <div>
            <p className="text-sm text-muted-foreground">Password reset successfully!</p>
            <Link to="/login" className="text-[12px] font-semibold mt-4 inline-block" style={{ color: '#E04B2A' }} data-testid="reset-sign-in-link">Sign in with new password</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 mt-6">
            <div>
              <Label className="text-[11px] font-semibold text-muted-foreground uppercase tracking-[0.08em]">New Password</Label>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} className="mt-1 rounded-lg h-11 text-sm" required data-testid="reset-password" />
            </div>
            <div>
              <Label className="text-[11px] font-semibold text-muted-foreground uppercase tracking-[0.08em]">Confirm Password</Label>
              <Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} className="mt-1 rounded-lg h-11 text-sm" required data-testid="reset-confirm" />
            </div>
            {error && <p className="text-xs font-medium px-3 py-2.5 rounded-lg border" style={{ color: '#E04B2A', backgroundColor: 'rgba(224,75,42,0.06)', borderColor: 'rgba(224,75,42,0.15)' }}>{error}</p>}
            <Button type="submit" disabled={loading} className="w-full h-11 rounded-lg text-sm font-bold text-white" style={{ backgroundColor: '#E04B2A' }} data-testid="reset-submit">
              {loading ? 'Resetting...' : 'Reset password'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
